import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "product-list-paging-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showPageUpButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["product-list-paging-wrapper__button product-list-paging-wrapper__button--top | button", {'button--loading': _ctx.isLoading}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPage(_ctx.getPrevPageNum(), 'prepend')))
        }, _toDisplayString(_ctx.$t('product_list.paging.load_more')), 3 /* TEXT, CLASS */))
      : _createCommentVNode("v-if", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _renderSlot(_ctx.$slots, "default"),
    _cache[3] || (_cache[3] = _createTextVNode()),
    (_ctx.showPageDownButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["product-list-paging-wrapper__button product-list-paging-wrapper__button--bottom | button", {'button--loading': _ctx.isLoading}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPage(_ctx.getNextPageNum(), 'append')))
        }, _toDisplayString(_ctx.$t('product_list.paging.load_more')), 3 /* TEXT, CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}